<template>
  <div>
    <!-- Summary Cards -->
    <div class="row" v-if="summary && isGraph">
      <div class="col-lg-3 col-xs-6">
        <div class="small-box bg-aqua">
          <div class="inner">
            <h3>{{ summary.totalBranches }}</h3>
            <p>Total Branches</p>
          </div>
          <div class="icon">
            <i class="fa fa-building"></i>
          </div>
          <a href="#" class="small-box-footer">&nbsp;</a>
        </div>
      </div>
      <div class="col-lg-3 col-xs-6">
        <div class="small-box bg-green">
          <div class="inner">
            <h3>{{ summary.totalMonths }}</h3>
            <p>Total Months</p>
          </div>
          <div class="icon">
            <i class="fa fa-calendar"></i>
          </div>
          <a href="#" class="small-box-footer">&nbsp;</a>
        </div>
      </div>
      <div class="col-lg-3 col-xs-6">
        <div class="small-box bg-yellow">
          <div class="inner">
            <h3>{{ formatCurrency(summary.totalInvoices) }}</h3>
            <p>Total Revenue</p>
          </div>
          <div class="icon">
            <i class="fa fa-money"></i>
          </div>
          <a href="#" class="small-box-footer">&nbsp;</a>
        </div>
      </div>
      <div class="col-lg-3 col-xs-6">
        <div class="small-box bg-red">
          <div class="inner">
            <h3>{{ formatCurrency(summary.totalProfit) }}</h3>
            <p>Total Profit</p>
          </div>
          <div class="icon">
            <i class="fa fa-line-chart"></i>
          </div>
          <a href="#" class="small-box-footer">&nbsp;</a>
        </div>
      </div>
    </div>

    <!-- Charts Row -->
    <div class="row">
      <!-- Branch Monthly Performance Chart -->
      <div class="col-md-6" v-if="isGraph">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Branch Monthly Performance</h3>
          </div>
          <div class="box-body">
            <apexchart type="line" height="350" :options="branchMonthlyPerformanceChartData.options"
              :series="branchMonthlyPerformanceChartData.series" v-if="records.length > 0"></apexchart>
            <div v-else
              style="height: 350px; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;">
              <div style="text-align: center; color: #666;">
                <i class="fa fa-line-chart fa-2x"></i>
                <p style="margin-top: 10px;">No data available</p>
                <small>Please load data to view charts</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Profit/Loss Distribution -->
      <div class="col-md-6" v-if="isGraph">
        <div class="box box-warning">
          <div class="box-header with-border">
            <h3 class="box-title">Profit/Loss Distribution</h3>
          </div>
          <div class="box-body">
            <apexchart type="donut" height="350" :options="profitLossDistributionChartData.options"
              :series="profitLossDistributionChartData.series" v-if="records.length > 0"></apexchart>
            <div v-else
              style="height: 350px; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;">
              <div style="text-align: center; color: #666;">
                <i class="fa fa-pie-chart fa-2x"></i>
                <p style="margin-top: 10px;">No data available</p>
                <small>Please load data to view charts</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <div class="box box-default">
      <div class="box-header with-border">
        <h3 class="box-title">Branch-wise Monthly Growth Data</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-success btn-sm" @click="exportToExcel">
            <i class="fa fa-download"></i> Export Excel
          </button>
        </div>
      </div>
      <div class="box-body">
        <div class="table-responsive">
          <table class="table table-bordered matrix-table text-center">
            <thead>
              <tr>
                <th rowspan="2">SN</th>
                <th rowspan="2">Branch</th>
                <th rowspan="2">Branch Totals</th>
                <th v-for="m in uniqueMonths" :key="'header-' + m" colspan="1">
                  {{ formatMonth(m) }}
                </th>
                <th rowspan="2">Branch Totals</th>
              </tr>
              <tr>
                <th v-for="m in uniqueMonths" :key="'subheader-' + m">
                  <div class="header-content">
                    <div class="header-top">
                      <span class="header-left">sales.</span>
                      <span class="header-right">PL Amt</span>
                    </div>
                    <div class="header-middle">
                      <span class="header-left">-----</span>
                      <span class="header-center">|</span>
                      <span class="header-right">-----</span>
                    </div>
                    <div class="header-bottom">
                      <span class="header-left">Exp.</span>
                      <span class="header-right">PL%</span>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr v-for="(branch, index) in paginatedPivotData" :key="'row-' + (branch ? branch.branchId : index)"
                :class="getBranchRowClass(branch)"> -->
              <tr v-for="(branch, index) in paginatedPivotData" :class="[
                getBranchRowClass(branch),
                isBestBranch(branch) ? 'best-branch' : '',
                isWorstBranch(branch) ? 'worst-branch' : ''
              ]">

                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                <td class="text-left">
                  <b>{{ branch ? branch.branchLocation : 'Unknown' }}</b>
                </td>
                   <!-- Total Summary column -->
                <td class="monthly-cell">
                  <div class="month-grid">

                    <!-- Sales -->
                    <!-- <div class="grid-box sales-box"> -->
                      <div class="grid-box sales-box"
     :class="(calculateBranchTotal(branch, 'totalInvoices') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Sales</div>
                      <div class="grid-value">
                        <!-- {{ formatCurrency(calculateBranchTotal(branch, 'totalInvoices')) }} -->
                        {{ getTrendIcon(calculateBranchTotal(branch, 'totalInvoices')) }} {{ formatCurrency(calculateBranchTotal(branch, 'totalInvoices')) }}
                      </div>
                    </div>

                    <!-- PL Amt -->
                    <!-- <div class="grid-box pl-box"> -->
                      <div class="grid-box pl-box"
     :class="(calculateBranchTotal(branch, 'totalProfit') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL Amt</div>
                      <div class="grid-value" :class="getProfitClass(calculateBranchTotal(branch, 'totalProfit'))">
                        <!-- {{ formatCurrency(calculateBranchTotal(branch, 'totalProfit')) }} -->
                        {{ getTrendIcon(calculateBranchTotal(branch, 'totalProfit')) }} {{ formatCurrency(calculateBranchTotal(branch, 'totalProfit')) }}
                      </div>
                    </div>

                    <!-- Expenses -->
                    <!-- <div class="grid-box exp-box"> -->
                      <div class="grid-box exp-box"
     :class="(calculateBranchTotal(branch, 'totalExpenses') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Exp</div>
                      <div class="grid-value text-muted">
                        <!-- {{ formatCurrency(calculateBranchTotal(branch, 'totalExpenses')) }} -->
                        {{ getTrendIcon(calculateBranchTotal(branch, 'totalExpenses')) }} {{ formatCurrency(calculateBranchTotal(branch, 'totalExpenses')) }}
                      </div>
                    </div>

                    <!-- PL % -->
                    <!-- <div class="grid-box percent-box"> -->
                      <div class="grid-box percent-box"
     :class="(calculateBranchPercentage(branch) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL %</div>
                      <div class="grid-value" :class="getPercentageClass(calculateBranchPercentage(branch))">
                        {{  calculateBranchPercentage(branch).toFixed(1) }}%
                      </div>
                    </div>

                  </div>
                </td>
                <!-- For each month: Combined Sale/Exp | P/L data -->
                <td v-for="m in uniqueMonths" :key="'combined-' + (branch ? branch.branchId : 'unknown') + '-' + m"
                  class="monthly-cell">
                  <div class="month-grid">
                    <!-- Sales -->
                    <!-- <div class="grid-box sales-box"> -->
                      <div class="grid-box sales-box"
                        :class="((branch.monthlyData[m] && branch.monthlyData[m].totalInvoices) || 0) >= 0 ? 'positive' : 'negative'">
                        <div class="grid-label">Sales</div>
                        <div class="grid-value">
                          {{ getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].totalInvoices) || 0) }} {{ formatCurrency((branch.monthlyData[m] && branch.monthlyData[m].totalInvoices) || 0) }}
                        </div>
                      </div>

                    <!-- PL Amount -->
                    <!-- <div class="grid-box pl-box"> -->
                      <div class="grid-box pl-box"
                        :class="((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0) >= 0 ? 'positive' : 'negative'">
                        <div class="grid-label">PL Amt</div>
                        <div class="grid-value" :class="getProfitClass((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0)">
                          {{ getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0) }} {{ formatCurrency((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0) }}
                        </div>
                      </div>

                    <!-- Expenses -->
                    <!-- <div class="grid-box exp-box"> -->
                      <div class="grid-box exp-box"
                        :class="((branch.monthlyData[m] && branch.monthlyData[m].totalExpenses) || 0) >= 0 ? 'positive' : 'negative'">
                        <div class="grid-label">Exp</div>
                        <div class="grid-value text-muted">
                          {{ getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].totalExpenses) || 0) }} {{ formatCurrency((branch.monthlyData[m] && branch.monthlyData[m].totalExpenses) || 0) }}
                        </div>
                      </div>

                    <!-- PL % -->
                    <!-- <div class="grid-box percent-box"> -->
                      <div class="grid-box percent-box"
                        :class="((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0) >= 0 ? 'positive' : 'negative'">
                        <div class="grid-label">PL %</div>
                        <div class="grid-value" :class="getPercentageClass((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0)">
                          {{ getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0) }} {{ ((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0).toFixed(1) }}%
                        </div>
                      </div>
                  </div>
                </td>

               <!-- Total Summary column -->
                <td class="monthly-cell">
                  <div class="month-grid">

                    <!-- Sales -->
                    <!-- <div class="grid-box sales-box"> -->
                      <div class="grid-box sales-box"
     :class="(calculateBranchTotal(branch, 'totalInvoices') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Sales</div>
                      <div class="grid-value">
                        <!-- {{ formatCurrency(calculateBranchTotal(branch, 'totalInvoices')) }} -->
                        {{ getTrendIcon(calculateBranchTotal(branch, 'totalInvoices')) }} {{ formatCurrency(calculateBranchTotal(branch, 'totalInvoices')) }}
                      </div>
                    </div>

                    <!-- PL Amt -->
                    <!-- <div class="grid-box pl-box"> -->
                      <div class="grid-box pl-box"
     :class="(calculateBranchTotal(branch, 'totalProfit') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL Amt</div>
                      <div class="grid-value" :class="getProfitClass(calculateBranchTotal(branch, 'totalProfit'))">
                        <!-- {{ formatCurrency(calculateBranchTotal(branch, 'totalProfit')) }} -->
                        {{ getTrendIcon(calculateBranchTotal(branch, 'totalProfit')) }} {{ formatCurrency(calculateBranchTotal(branch, 'totalProfit')) }}
                      </div>
                    </div>

                    <!-- Expenses -->
                    <!-- <div class="grid-box exp-box"> -->
                      <div class="grid-box exp-box"
     :class="(calculateBranchTotal(branch, 'totalExpenses') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Exp</div>
                      <div class="grid-value text-muted">
                        <!-- {{ formatCurrency(calculateBranchTotal(branch, 'totalExpenses')) }} -->
                        {{ getTrendIcon(calculateBranchTotal(branch, 'totalExpenses')) }} {{ formatCurrency(calculateBranchTotal(branch, 'totalExpenses')) }}
                      </div>
                    </div>

                    <!-- PL % -->
                    <!-- <div class="grid-box percent-box"> -->
                      <div class="grid-box percent-box"
     :class="(calculateBranchPercentage(branch) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL %</div>
                      <div class="grid-value" :class="getPercentageClass(calculateBranchPercentage(branch))">
                        {{  calculateBranchPercentage(branch).toFixed(1) }}%
                      </div>
                    </div>

                  </div>
                </td>


              </tr>
            </tbody>
            <tfoot>
              <tr class="bg-light font-weight-bold">
                <td colspan="2">TOTAL</td>
                 <!-- Overall summary -->
                <td class="monthly-cell">
                  <div class="month-grid">

                    <!-- Sales -->
                    <!-- <div class="grid-box sales-box"> -->
                      <div class="grid-box sales-box"
     :class="((summary && summary.totalInvoices) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Sales</div>
                      <div class="grid-value">
                        <!-- {{ formatCurrency((summary && summary.totalInvoices) || 0) }} -->
                        {{ getTrendIcon((summary && summary.totalInvoices) || 0) }} {{ formatCurrency((summary && summary.totalInvoices) || 0) }}
                      </div>
                    </div>

                    <!-- PL Amt -->
                    <!-- <div class="grid-box pl-box"> -->
                      <div class="grid-box pl-box"
     :class="((summary && summary.totalProfit) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL Amt</div>
                      <div class="grid-value" :class="getProfitClass((summary && summary.totalProfit) || 0)">
                        <!-- {{ formatCurrency((summary && summary.totalProfit) || 0) }} -->
                        {{ getTrendIcon((summary && summary.totalProfit) || 0) }} {{ formatCurrency((summary && summary.totalProfit) || 0) }}
                      </div>
                    </div>

                    <!-- Expenses -->
                      <!-- <div class="grid-box exp-box"> -->
                      <div class="grid-box exp-box"
     :class="((summary && summary.totalExpenses) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Exp</div>
                      <div class="grid-value text-muted">
                        <!-- {{ formatCurrency((summary && summary.totalExpenses) || 0) }} -->
                        {{ getTrendIcon((summary && summary.totalExpenses) || 0) }} {{ formatCurrency((summary && summary.totalExpenses) || 0) }}
                      </div>
                    </div>

                    <!-- PL % -->
                    <!-- <div class="grid-box percent-box"> -->
                      <div class="grid-box percent-box"
     :class="(calculateOverallPercentage() || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL %</div>
                      <div class="grid-value" :class="getPercentageClass(calculateOverallPercentage())">
                        <!-- {{ calculateOverallPercentage().toFixed(1) }}% -->
                        {{ getTrendIcon(calculateOverallPercentage()) }} {{ calculateOverallPercentage().toFixed(1) }}%
                      </div>
                    </div>

                  </div>
                </td>
                <!-- For each month: Combined totals -->
                <td v-for="m in uniqueMonths" :key="'total-' + m" class="monthly-cell">
                  <div class="month-grid">

                    <!-- Sales -->
                    <!-- <div class="grid-box sales-box"> -->
                      <div class="grid-box sales-box"
     :class="(getMonthTotal(m, 'totalInvoices') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Sales</div>
                      <div class="grid-value">
                        <!-- {{ formatCurrency(getMonthTotal(m, 'totalInvoices')) }} -->
                        {{ getTrendIcon(getMonthTotal(m, 'totalInvoices')) }} {{ formatCurrency(getMonthTotal(m, 'totalInvoices')) }}
                      </div>
                    </div>

                    <!-- PL Amt -->
                    <!-- <div class="grid-box pl-box"> -->
                      <div class="grid-box pl-box"
     :class="(getMonthTotal(m, 'totalProfit') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL Amt</div>
                      <div class="grid-value" :class="getProfitClass(getMonthTotal(m, 'totalProfit'))">
                        <!-- {{ formatCurrency(getMonthTotal(m, 'totalProfit')) }} -->
                        {{ getTrendIcon(getMonthTotal(m, 'totalProfit')) }} {{ formatCurrency(getMonthTotal(m, 'totalProfit')) }}
                      </div>
                    </div>

                    <!-- Expenses -->
                    <!-- <div class="grid-box exp-box"> -->
                      <div class="grid-box exp-box"
     :class="(getMonthTotal(m, 'totalExpenses') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Exp</div>
                      <div class="grid-value text-muted">
                        <!-- {{ formatCurrency(getMonthTotal(m, 'totalExpenses')) }} -->
                        {{ getTrendIcon(getMonthTotal(m, 'totalExpenses')) }} {{ formatCurrency(getMonthTotal(m, 'totalExpenses')) }}
                      </div>
                    </div>

                    <!-- PL % -->
                    <!-- <div class="grid-box percent-box"> -->
                      <div class="grid-box percent-box"
     :class="(getMonthTotal(m, 'profitPercentage') || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL %</div>
                      <div class="grid-value" :class="getPercentageClass(getMonthTotal(m, 'profitPercentage'))">
                        {{ getTrendIcon(getMonthTotal(m, 'profitPercentage')) }} {{ getMonthTotal(m, 'profitPercentage').toFixed(1) }}%
                      </div>
                    </div>

                  </div>
                </td>

                <!-- Overall summary -->
                <td class="monthly-cell">
                  <div class="month-grid">

                    <!-- Sales -->
                    <!-- <div class="grid-box sales-box"> -->
                      <div class="grid-box sales-box"
     :class="((summary && summary.totalInvoices) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Sales</div>
                      <div class="grid-value">
                        <!-- {{ formatCurrency((summary && summary.totalInvoices) || 0) }} -->
                        {{ getTrendIcon((summary && summary.totalInvoices) || 0) }} {{ formatCurrency((summary && summary.totalInvoices) || 0) }}
                      </div>
                    </div>

                    <!-- PL Amt -->
                    <!-- <div class="grid-box pl-box"> -->
                      <div class="grid-box pl-box"
     :class="((summary && summary.totalProfit) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL Amt</div>
                      <div class="grid-value" :class="getProfitClass((summary && summary.totalProfit) || 0)">
                        <!-- {{ formatCurrency((summary && summary.totalProfit) || 0) }} -->
                        {{ getTrendIcon((summary && summary.totalProfit) || 0) }} {{ formatCurrency((summary && summary.totalProfit) || 0) }}
                      </div>
                    </div>

                    <!-- Expenses -->
                      <!-- <div class="grid-box exp-box"> -->
                      <div class="grid-box exp-box"
     :class="((summary && summary.totalExpenses) || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">Exp</div>
                      <div class="grid-value text-muted">
                        <!-- {{ formatCurrency((summary && summary.totalExpenses) || 0) }} -->
                        {{ getTrendIcon((summary && summary.totalExpenses) || 0) }} {{ formatCurrency((summary && summary.totalExpenses) || 0) }}
                      </div>
                    </div>

                    <!-- PL % -->
                    <!-- <div class="grid-box percent-box"> -->
                      <div class="grid-box percent-box"
     :class="(calculateOverallPercentage() || 0) >= 0 ? 'positive' : 'negative'">

                      <div class="grid-label">PL %</div>
                      <div class="grid-value" :class="getPercentageClass(calculateOverallPercentage())">
                        <!-- {{ calculateOverallPercentage().toFixed(1) }}% -->
                        {{ getTrendIcon(calculateOverallPercentage()) }} {{ calculateOverallPercentage().toFixed(1) }}%
                      </div>
                    </div>

                  </div>
                </td>


              </tr>
            </tfoot>
          </table>
        </div>


        <!-- Pagination -->
        <div class="d-flex justify-content-between align-items-center mt-3" v-if="totalBranchRows > perPage">

          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0">Show:</label>
            <b-form-select v-model="perPage" :options="pageOptions" size="sm" class="w-auto"></b-form-select>
            <span class="ml-2 text-muted">entries</span>
          </div>

          <b-pagination v-model="currentPage" :total-rows="totalBranchRows" :per-page="perPage" size="sm" class="mb-0"
            first-number last-number></b-pagination>

          <div class="text-muted small">
            Showing {{ (currentPage - 1) * perPage + 1 }} to {{ Math.min(currentPage * perPage, totalBranchRows) }} of
            {{ totalBranchRows }} entries
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GrowthDashboardService from '../../../services/GrowthDashboardService';
import VueApexCharts from 'vue-apexcharts';
import * as XLSX from 'xlsx';

export default {
  name: 'BranchWiseMonthlyGrowthComponent',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    isGraph: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      records: [],
      summary: null,
      // Pagination
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    };
  },

  watch: {
    records(newVal) {
      this.totalRows = newVal.length;
    }
  },

  computed: {
    uniqueMonths() {
      if (!this.records || this.records.length === 0) return [];
      // Get all months from all branches' monthlyData
      const allMonths = new Set();
      this.records.forEach(branch => {
        if (branch.monthlyData) {
          Object.keys(branch.monthlyData).forEach(month => allMonths.add(month));
        }
      });
      return Array.from(allMonths).sort();
    },

    pivotData() {
      // Data is already grouped by branch from backend
      return this.records || [];
    },

    paginatedPivotData() {
      return this.pivotData.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },

    totalBranchRows() {
      return this.pivotData.length;
    },

    // Chart data for Branch Monthly Performance Line Chart
    branchMonthlyPerformanceChartData() {
      if (!this.records || this.records.length === 0) {
        return {
          series: [],
          options: {}
        };
      }

      // Sort branches by total profit and take top 5
      const topBranches = [...this.records]
        .sort((a, b) => (b.totalProfit || 0) - (a.totalProfit || 0))
        .slice(0, 5);

      const series = topBranches.map(branch => ({
        name: branch.branchLocation || 'Unknown',
        data: this.uniqueMonths.map(month => {
          const monthData = branch.monthlyData[month];
          return monthData ? (monthData.totalProfit || 0) : 0;
        })
      }));

      return {
        series: series,
        options: {
          chart: {
            type: 'line',
            height: 350,
            toolbar: {
              show: true
            }
          },
          stroke: {
            curve: 'smooth',
            width: 3
          },
          xaxis: {
            categories: this.uniqueMonths.map(month => this.formatMonth(month)),
            title: {
              text: 'Month'
            }
          },
          yaxis: {
            title: {
              text: 'Profit Amount (₹)'
            },
            labels: {
              formatter: function (value) {
                return '₹' + (value / 100000).toFixed(0) + 'L';
              }
            }
          },
          colors: ['#00E396', '#775DD0', '#FF4560', '#FEB019', '#008FFB'],
          tooltip: {
            y: {
              formatter: function (value) {
                return '₹' + value.toLocaleString('en-IN');
              }
            }
          },
          legend: {
            position: 'top'
          }
        }
      };
    },

    // Chart data for Profit/Loss Distribution Donut Chart
    profitLossDistributionChartData() {
      if (!this.records || this.records.length === 0) {
        return {
          series: [],
          options: {}
        };
      }

      let profitableMonths = 0;
      let lossMonths = 0;
      let breakEvenMonths = 0;

      // Count months across all branches
      this.records.forEach(branch => {
        if (branch.monthlyData) {
          Object.values(branch.monthlyData).forEach((monthData) => {
            const profit = monthData.totalProfit || 0;
            if (profit > 0) profitableMonths++;
            else if (profit < 0) lossMonths++;
            else breakEvenMonths++;
          });
        }
      });

      return {
        series: [profitableMonths, lossMonths, breakEvenMonths],
        options: {
          chart: {
            type: 'donut',
            height: 350
          },
          labels: ['Profitable Months', 'Loss Months', 'Break Even Months'],
          colors: ['#00E396', '#FF4560', '#FEB019'],
          legend: {
            position: 'bottom'
          },
          tooltip: {
            y: {
              formatter: function (value) {
                return value + ' months';
              }
            }
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    }
                  }
                }
              }
            }
          }
        }
      };
    },

  },
  watch: {
    filters: {
      handler() {
        this.loadData();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getTrendIcon(value) {
      if (value > 0) return '▲'
      if (value < 0) return '▼'
      return '■'
    },

    isBestBranch(branch) {
      if (!this.records.length) return false
      const max = Math.max(...this.records.map(b => b.totalProfit || 0))
      return branch.totalProfit === max
    },

    isWorstBranch(branch) {
      if (!this.records.length) return false
      const min = Math.min(...this.records.map(b => b.totalProfit || 0))
      return branch.totalProfit === min
    },

    calculateSummaryFromRecords(records) {
      if (!records || records.length === 0) {
        return {
          totalBranches: 0,
          totalMonths: 0,
          totalInvoices: 0,
          totalExpenses: 0,
          totalProfit: 0,
          totalJobs: 0
        };
      }

      let totalBranches = records.length;
      let totalMonths = 0;
      let totalInvoices = 0;
      let totalExpenses = 0;
      let totalProfit = 0;
      let totalJobs = 0;

      records.forEach(branch => {
        totalProfit += branch.totalProfit || 0;

        if (branch.monthlyData) {
          Object.values(branch.monthlyData).forEach((monthData) => {
            totalMonths++;
            totalInvoices += monthData.totalInvoices || 0;
            totalExpenses += monthData.totalExpenses || 0;
            totalJobs += monthData.totalJobs || 0;
          });
        }
      });

      return {
        totalBranches,
        totalMonths,
        totalInvoices,
        totalExpenses,
        totalProfit,
        totalJobs
      };
    },

    async loadData() {
      try {
        this.$emit('loading', true);

        const params = {};
        Object.keys(this.filters).forEach(key => {
          if (this.filters[key] !== null && this.filters[key] !== '') {
            params[key] = this.filters[key];
          }
        });

        const response = await GrowthDashboardService.getBranchWiseGrowthDataMonthly(params);

        if (response.data.success) {
          this.records = response.data.data.records;

          // Calculate summary from the grouped data
          this.summary = this.calculateSummaryFromRecords(this.records);
        }
      } catch (error) {
        console.error('Error loading branch-wise monthly growth data:', error);
        
      } finally {
        this.$emit('loading', false);
      }
    },

    formatCurrency(amount) {
      if (amount === null || amount === undefined) return '₹0';
      return '₹' + Math.abs(amount).toLocaleString('en-IN');
    },

    formatMonth(monthStr) {
      if (!monthStr) return '';
      const [year, month] = monthStr.split('-');
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      return `${monthNames[parseInt(month) - 1]} ${year}`;
    },

    getMonthTotal(month, field) {
      return this.records
        .filter(branch => branch.monthlyData && branch.monthlyData[month])
        .reduce((sum, branch) => sum + (branch.monthlyData[month][field] || 0), 0);
    },

    getBranchRowClass(branch) {
      // Color based on overall profitability
      if (branch && branch.totalProfit > 0) return 'table-success';
      if (branch && branch.totalProfit < 0) return 'table-danger';
      return '';
    },

    getProfitClass(amount) {
      return amount >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold';
    },

    getPercentageClass(percentage) {
      if (percentage > 0) return 'text-success';
      if (percentage < 0) return 'text-danger';
      return 'text-muted';
    },

    getRevenueClass(amount) {
      return amount > 0 ? 'text-primary' : 'text-muted';
    },

    getExpenseClass(amount) {
      return amount > 0 ? 'text-warning' : 'text-muted';
    },

    getStatusClass(status) {
      switch (status) {
        case 'Profit': return 'label-success';
        case 'Loss': return 'label-danger';
        default: return 'label-default';
      }
    },

    calculateBranchTotal(branch, field) {
      if (!branch || !branch.monthlyData) return 0;
      return Object.values(branch.monthlyData).reduce((sum, monthData) => {
        return sum + (monthData[field] || 0);
      }, 0);
    },

    calculateBranchPercentage(branch) {
      if (!branch || !branch.monthlyData) return 0;
      const totalInvoices = this.calculateBranchTotal(branch, 'totalInvoices');
      const totalProfit = this.calculateBranchTotal(branch, 'totalProfit');
      return totalInvoices ? (totalProfit / totalInvoices) * 100 : 0;
    },

    calculateOverallPercentage() {
      if (!this.summary) return 0;
      const totalInvoices = this.summary.totalInvoices || 0;
      const totalProfit = this.summary.totalProfit || 0;
      return totalInvoices ? (totalProfit / totalInvoices) * 100 : 0;
    },

    buildExportRows() {
      const exportRows = [];
      const months = this.uniqueMonths;

      this.pivotData.forEach((branch, index) => {
        const row = {
          SN: index + 1,
          Branch: branch ? (branch.branchLocation || 'Unknown') : 'Unknown',
          'Branch Total Sales': this.calculateBranchTotal(branch, 'totalInvoices'),
          'Branch Total Exp': this.calculateBranchTotal(branch, 'totalExpenses'),
          'Branch Total PL Amt': this.calculateBranchTotal(branch, 'totalProfit'),
          'Branch Total PL %': Number(this.calculateBranchPercentage(branch).toFixed(1))
        };

        months.forEach((month) => {
          const monthLabel = this.formatMonth(month);
          const monthData = (branch && branch.monthlyData && branch.monthlyData[month]) || {};
          const monthSales = monthData.totalInvoices || 0;
          const monthProfit = monthData.totalProfit || 0;
          const monthExpenses = monthData.totalExpenses || 0;
          const monthPercentage = monthData.profitPercentage || 0;

          row[`${monthLabel} Sales`] = monthSales;
          row[`${monthLabel} PL Amt`] = monthProfit;
          row[`${monthLabel} Exp`] = monthExpenses;
          row[`${monthLabel} PL %`] = Number(monthPercentage.toFixed(1));
        });

        row['Grand Total Sales'] = this.calculateBranchTotal(branch, 'totalInvoices');
        row['Grand Total PL Amt'] = this.calculateBranchTotal(branch, 'totalProfit');
        row['Grand Total Exp'] = this.calculateBranchTotal(branch, 'totalExpenses');
        row['Grand Total PL %'] = Number(this.calculateBranchPercentage(branch).toFixed(1));

        exportRows.push(row);
      });

      const totalRow = {
        SN: '',
        Branch: 'TOTAL',
        'Branch Total Sales': (this.summary && this.summary.totalInvoices) || 0,
        'Branch Total PL Amt': (this.summary && this.summary.totalProfit) || 0,
        'Branch Total Exp': (this.summary && this.summary.totalExpenses) || 0,
        'Branch Total PL %': Number(this.calculateOverallPercentage().toFixed(1))
      };

      months.forEach((month) => {
        const monthLabel = this.formatMonth(month);
        const monthSales = this.getMonthTotal(month, 'totalInvoices');
        const monthProfit = this.getMonthTotal(month, 'totalProfit');
        const monthExpenses = this.getMonthTotal(month, 'totalExpenses');
        const monthPercentage = monthSales ? (monthProfit / monthSales) * 100 : 0;

        totalRow[`${monthLabel} Sales`] = monthSales;
        totalRow[`${monthLabel} PL Amt`] = monthProfit;
        totalRow[`${monthLabel} Exp`] = monthExpenses;
        totalRow[`${monthLabel} PL %`] = Number(monthPercentage.toFixed(1));
      });

      totalRow['Grand Total Sales'] = (this.summary && this.summary.totalInvoices) || 0;
      totalRow['Grand Total PL Amt'] = (this.summary && this.summary.totalProfit) || 0;
      totalRow['Grand Total Exp'] = (this.summary && this.summary.totalExpenses) || 0;
      totalRow['Grand Total PL %'] = Number(this.calculateOverallPercentage().toFixed(1));

      exportRows.push(totalRow);
      return exportRows;
    },

    async exportToExcel() {
      try {
        if (!this.records || this.records.length === 0) {
          if (this.$bvToast) {
            this.$bvToast.toast('No data available to export.', {
              title: 'Export',
              variant: 'warning',
              solid: true
            });
          }
          return;
        }

        const exportRows = this.buildExportRows();
        const worksheet = XLSX.utils.json_to_sheet(exportRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Branch Monthly Growth');

        const timestamp = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(workbook, `Branch_Wise_Monthly_Growth_${timestamp}.xlsx`);

        if (this.$bvToast) {
          this.$bvToast.toast('Excel exported successfully.', {
            title: 'Export',
            variant: 'success',
            solid: true
          });
        }
      } catch (error) {
        console.error('Error exporting branch-wise monthly data:', error);
        if (this.$bvToast) {
          this.$bvToast.toast('Failed to export excel file.', {
            title: 'Export Error',
            variant: 'danger',
            solid: true
          });
        }
      }
    }
  },

  mounted() {
    this.loadData();
  },

  beforeDestroy() {
    // No chart cleanup needed
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

.table {
  margin-bottom: 0;
}

.table th {
  vertical-align: middle;
  font-weight: 600;
  border-top: 2px solid #dee2e6;
}

.table th small {
  font-weight: normal;
  color: #6c757d;
}

.table td {
  vertical-align: middle;
  padding: 8px 4px;
}

.profit-cell {
  line-height: 1.2;
}

.profit-cell small {
  display: block;
  font-size: 11px;
  margin-top: 2px;
}

.bg-gray {
  background-color: #f5f5f5 !important;
}

.label {
  display: inline-block;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 4px;
}

.label-success {
  background-color: #5cb85c;
}

.label-danger {
  background-color: #d9534f;
}

.label-default {
  background-color: #999;
}

.small-box {
  margin-bottom: 15px;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.text-success {
  color: #3c763d !important;
}

.text-danger {
  color: #a94442 !important;
}

.text-muted {
  color: #999 !important;
}

.table-success {
  background-color: rgba(40, 167, 69, 0.1);
}

.table-danger {
  background-color: rgba(220, 53, 69, 0.1);
}

/* Header styling */
.header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  line-height: 1.1;
  padding: 2px 0;
}

.header-top,
.header-middle,
.header-bottom {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.header-left {
  text-align: left;
  flex: 1;
}

.header-center {
  text-align: center;
  flex: 0 0 auto;
  margin: 0 2px;
  font-weight: bold;
}

.header-right {
  text-align: right;
  flex: 1;
}

.header-middle .header-left,
.header-middle .header-right {
  letter-spacing: -1px;
}

.month-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  font-size: 11px;
}

.grid-box {
  padding: 6px 4px;
  text-align: center;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.grid-box:nth-child(2n) {
  border-right: none;
}

.grid-box:nth-child(3),
.grid-box:nth-child(4) {
  border-bottom: none;
}

.grid-label {
  font-size: 9px;
  color: #666;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.grid-value {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.sales-box {
  background: #f9fbff;
}

.exp-box {
  background: #fcfcfc;
}

.pl-box {
  background: #f3fff7;
}

.percent-box {
  background: #fffaf3;
}

/* Monthly cell styling */
.monthly-cell {
  padding: 4px 2px !important;
  min-height: 70px;
  min-width: 140px;
}

.cell-content {
  display: block;
  font-size: 9px;
  line-height: 1.1;
}

.data-row {
  display: flex;
  align-items: center;
  gap: 2px;
}

.data-label {
  font-size: 8px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
}

.data-value {
  font-size: 9px;
  font-weight: 600;
  white-space: nowrap;
}

.data-separator {
  color: #666;
  font-size: 12px;
  font-weight: bold;
  margin: 0 4px;
}

.inline-separator {
  color: #666;
  font-size: 10px;
  font-weight: bold;
  margin-left: 4px;
}

.cell-content .sales-amount,
.cell-content .expenses-amount,
.cell-content .profit-amount,
.cell-content .percentage-amount {
  text-align: center;
  white-space: nowrap;
}

.cell-content .sales-amount {
  font-weight: 600;
}

.cell-content .expenses-amount {
  font-size: 10px;
}

.cell-content .profit-amount {
  font-weight: 600;
}

.cell-content .percentage-amount {
  font-size: 10px;
}

/* Responsive adjustments for the pivot table */
@media (max-width: 768px) {

  .table th,
  .table td {
    padding: 4px 2px;
    font-size: 12px;
  }

  .profit-cell small {
    font-size: 10px;
  }

  .table th small {
    font-size: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// BranchWiseMonthlyGrowthComponent.vue?3d9e22d1